<template>
  <div class="myfinbiz-chat-survey">
    <div class="title-section">
      <h1 class="title">맞춤 서비스 Chat Finder</h1>
      <div class="title-underline"></div>
    </div>
    <div class="chat-container" ref="chatContainer">
      <div v-for="(message, index) in chatHistory" :key="index" :class="['message', message.type]">
        <div class="message-content">{{ message.content }}</div>
      </div>
    </div>
    <div class="user-input" v-if="currentQuestionIndex < questions.length - 1 && currentQuestion">
      <component
        :is="getComponent(currentQuestion.component)"
        v-model="userResponses[currentQuestionIndex]"
        :options="currentQuestion.options"
        :inputType="currentQuestion.inputType"
        @input="onInput"
        @select="handleInput"
        :key="`question-${currentQuestionIndex}`"
      />
      <button @click="handleInput" class="send-button" :disabled="!isValidInput">전송</button>
      <button @click="handleCancel" class="cancel-button" :disabled="currentQuestionIndex === 0">수정</button>
    </div>
    <div v-else-if="currentQuestionIndex === questions.length - 1 && !surveySubmitted" class="final-confirmation">
      <button @click="handleFinalConfirmation" class="confirm-button">정확히 입력했어요</button>
      <button @click="handleCancel" class="edit-button">수정</button>
    </div>
    <div v-else-if="surveySubmitted" class="survey-complete">
      <h2>감사합니다!</h2>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SelectInput from './SelectInput.vue'
import CheckboxInput from './CheckboxInput.vue'
import TextInput from './TextInput.vue'

export default {
  name: 'MyfinbizChatSurvey',
  components: {
    SelectInput,
    CheckboxInput,
    TextInput
  },
  data() {
    return {
      chatHistory: [
        { type: 'bot', content: '안녕하세요 사장님. 펀다는 소상공인 사장님들의 현금 흐름을 개선해서 매출 증진을 돕기 위한 "소상공인 종합 금융 패키지"를 제휴 파트너사들을 통해 제공하고 있습니다.' },
        { type: 'bot', content: '몇 가지 질문을 통해 고객님께 가장 적합한 파트너 서비스를 찾아드리겠습니다.' }
      ],
      currentQuestionIndex: -1,
      userResponses: [],
      isValidInput: false,
      questions: [
        {
          text: '어떤 업종을 운영하고 계신가요?',
          component: 'select',
          options: ['음식점', '배달전문', '학원', '숙박', '마트,도소매', '주유소', '기타']
        },
        {
          text: '사업장이 어느 지역에 계신가요?',
          component: 'select',
          options: ['서울', '인천','경기남부','경기북부', '충청', '부산,경상남도', '대구,경상북도', '전북', '전남', '강원', '제주']
        },
        {
          text: '월별 카드+배달 매출규모가 어떻게 되시나요?',
          component: 'select',
          options: ['1,000만원 이하', '1,000~2,000만원', '2,000~3,000만원', '3,000~4,000만원', '4,000~5,000만원', '5,000만원 이상']
        },
        {
          text: '마이핀비즈의 소상공인 금융 패키지 중에서 관심 있으신 서비스를 선택해주세요. (다중 선택 가능)',
          component: 'checkbox',
          options: [
            '365 오전 선정산',
            '5일매출 당겨받기',
            '우리동네 크라우드펀딩',
            '제휴 저축은행 대출 연결',
            '식자재 외상결제(예정)',
            '알바비 대신결제(예정)'
          ]
        },
        {
          text: '사장님 성함을 알려주세요.',
          component: 'input',
          inputType: 'text'
        },
        {
          text: '사업자 상호를 알려주세요.',
          component: 'input',
          inputType: 'text'
        },
        {
          text: '연락처를 알려주시면 상담원이 전화드리겠습니다.',
          component: 'input',
          inputType: 'tel'
        },
        {
          text: '모두 정확히 입력하셨나요? 입력하신 정보를 수정하시려면 수정 버튼을 눌러주세요.',
          component: 'confirmation'
        }
      ],
      surveySubmitted: false
    }
  },
  computed: {
    currentQuestion() {
      return this.currentQuestionIndex >= 0 && this.currentQuestionIndex < this.questions.length
        ? this.questions[this.currentQuestionIndex]
        : null
    }
  },
  mounted() {
    this.showNextQuestion()
    this.scrollToTop()
  },
  updated() {
    this.scrollToBottom()
  },
  methods: {
    ...mapActions('auth', ['earlyPaymentLoanRequest']),
    getComponent(componentName) {
      switch (componentName) {
        case 'select':
          return 'SelectInput'
        case 'checkbox':
          return 'CheckboxInput'
        case 'input':
          return 'TextInput'
        default:
          return null
      }
    },
    onInput(value) {
      this.userResponses[this.currentQuestionIndex] = value
      this.isValidInput = this.validateInput(value)
    },
    validateInput(value) {
      // 현재 질문의 inputType이 'tel'인 경우 (전화번호)
      if (this.currentQuestion && this.currentQuestion.inputType === 'tel') {
        // 8자리 숫자가 모두 입력되었는지 확인
        return value.replace(/\D/g, '').length === 11;
      }
      // 다른 질문들에 대한 기존 검증 로직
      if (Array.isArray(value)) {
        return value.length > 0
      }
      return value !== '' && value !== undefined && value !== null
    },
    handleInput() {
      if (this.isValidInput) {
        const response = this.userResponses[this.currentQuestionIndex]
        this.chatHistory.push({
          type: 'user',
          content: Array.isArray(response) ? response.join(', ') : response
        })
        this.showNextQuestion()
        // 입력창 초기화
        if (this.currentQuestion.component === 'input') {
          this.$nextTick(() => {
            this.userResponses[this.currentQuestionIndex] = ''
          })
        }
      }
    },
    handleCancel() {
      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex--
        this.chatHistory.pop() // 현재 질문 제거
        this.chatHistory.pop() // 이전 사용자 응답 제거
        this.isValidInput = true // 이전 응답은 이미 유효했으므로 true로 설정
      }
    },
    showNextQuestion() {
      this.currentQuestionIndex++
      this.isValidInput = false
      if (this.currentQuestionIndex < this.questions.length) {
        setTimeout(() => {
          this.chatHistory.push({ type: 'bot', content: this.questions[this.currentQuestionIndex].text })
        }, 500)
      }
    },
    handleFinalConfirmation() {
      this.submitSurvey()
    },
    async submitSurvey() {
      const customerInfo = {
        business_type: this.userResponses[0],
        region: this.userResponses[1],
        monthly_sales_amount: this.parseMonthlySalesAmount(this.userResponses[2]),
        interested_services: this.userResponses[3].join(', '),
        name: this.userResponses[4],
        store_name: this.userResponses[5],
        phone: this.userResponses[6]
      }

      try {
        const response = await this.earlyPaymentLoanRequest(customerInfo)
        console.log('API 응답:', response)
        this.chatHistory.push({ type: 'bot', content: '펀다 서비스에 관심을 가져주셔서 감사합니다. 곧 적합한 상담원을 찾아 연락드리겠습니다.' })
        this.surveySubmitted = true
      } catch (error) {
        console.error('API 호출 실패:', error)
        this.chatHistory.push({ type: 'bot', content: '죄송합니다. 요청 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.' })
      }
    },

    parseMonthlySalesAmount(salesRange) {
      const ranges = {
        '1,000만원 이하': 10000000,
        '1,000~2,000만원': 15000000,
        '2,000~3,000만원': 25000000,
        '3,000~4,000만원': 35000000,
        '4,000~5,000만원': 45000000,
        '5,000만원 이상': 50000000
      }
      return ranges[salesRange] || 0
    },
    scrollToBottom() {
      setTimeout(() => {
        if (this.$refs.chatContainer) {
          this.$refs.chatContainer.scrollTop = this.$refs.chatContainer.scrollHeight
        }
      }, 100)
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>
.myfinbiz-chat-survey {
  max-width: 800px;
  margin: 0 auto;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 600px;
}

.title-section {
  background-color: #0084ff;
  padding: 20px;
  text-align: center;
}

.title {
  color: white;
  font-size: 24px;
  margin: 0;
}

.title-underline {
  width: 50px;
  height: 3px;
  background-color: white;
  margin: 10px auto 0;
}

.chat-container {
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px;
  background-color: #f0f0f0;
}

.message {
  max-width: 80%;
  margin-bottom: 10px;
  clear: both;
}

.bot {
  float: left;
}

.user {
  float: right;
}

.message-content {
  padding: 10px;
  border-radius: 18px;
  display: inline-block;
}

.bot .message-content {
  background-color: #fff;
}

.user .message-content {
  background-color: #0084ff;
  color: white;
}

.user-input, .final-confirmation {
  display: flex;
  padding: 10px;
  background-color: #fff;
  border-top: 1px solid #ddd;
  align-items: flex-start;
  flex-wrap: wrap;
}

.user-input > * {
  margin-bottom: 10px;
}

.user-input > *:not(:last-child) {
  margin-right: 10px;
}

.chat-input {
  flex-grow: 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 20px;
  margin-right: 10px;
}

.send-button, .submit-button, .cancel-button, .confirm-button, .edit-button {
  background-color: #0084ff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  height: 40px;
  align-self: flex-start;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.send-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.send-button:hover:not(:disabled), .submit-button:hover, .confirm-button:hover {
  background-color: #0063cc;
}

.cancel-button, .edit-button {
  background-color: #3d3d3d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  margin-left: 10px;
}

.cancel-button:disabled {
  background-color: #ffcccc;
  cursor: not-allowed;
}

.cancel-button:hover:not(:disabled), .edit-button:hover {
  background-color: #4d4d4d;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 10px;
}

.checkbox-label {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}

.checkbox-label input {
  margin-right: 5px;
}

.survey-complete {
  padding: 20px;
  text-align: center;
}

.final-confirmation {
  justify-content: center;
}

.confirm-button, .edit-button {
  margin: 0 10px;
}
</style>